import { iconSrc, iconSrcForType } from "@/lib/azureIcons";

// Renders an official Azure/Entra product icon.
// Use `icon` for a registry key, or `type` for an ARM resource type.
export function AzureIcon({ icon, type, size = 20, className = "", alt, title }) {
  const src = type ? iconSrcForType(type) : iconSrc(icon || "generic");
  const label = alt ?? title ?? (icon || type || "resource");
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={label}
      title={title}
      draggable={false}
      loading="lazy"
      className={`inline-block shrink-0 select-none ${className}`}
      style={{ width: size, height: size }}
      onError={(e) => { if (!e.currentTarget.dataset.f) { e.currentTarget.dataset.f = "1"; e.currentTarget.src = iconSrc("generic"); } }}
    />
  );
}

export default AzureIcon;
